/** Правило записи на событие — одно для карточки, окна события и /e/{id}. */

const FREE_WORDS = new Set(["", "0", "бесплатно", "free", "входсвободный"]);

export function isFreePrice(price: string | null | undefined): boolean {
  const p = (price ?? "").toLowerCase().replace(/\s+/g, "");
  return FREE_WORDS.has(p);
}

export type RegistrationMode = "in_app" | "organizer";

export function registrationMode(event: {
  price?: string | null;
  signup_via_organizer?: boolean | null;
}): RegistrationMode {
  if (!isFreePrice(event.price) || event.signup_via_organizer) return "organizer";
  return "in_app";
}

/** Осталось мест (null — без ограничения). */
export function seatsLeft(maxAttendees: number | null | undefined, count: number): number | null {
  if (!maxAttendees) return null;
  return Math.max(0, maxAttendees - count);
}
